import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit Anti-Ghosting Terapéutico',
  desc: 'Protocolos para recuperar pacientes que desaparecen sin romper el encuadre.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Guiones de Contención en Crisis',
  desc: '40 frases listas para desborde emocional e ideación en sesión.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Bitácora Clínica del Terapeuta',
  desc: 'Registro de sesiones y seguimiento de avance por paciente.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Protocolo de Derivación Efectiva',
  desc: 'Cómo derivar con criterio clínico sin perder el vínculo.',
  price: '$9.000'
}, {
  num: '05',
  title: 'El Consultorio Rentable',
  desc: 'Honorarios, cancelaciones y organización profesional.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Blindaje Legal y Ético',
  desc: 'Consentimiento, encuadre legal y resguardo profesional en Argentina.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-47">
      <div className="mx-auto max-w-3xl" data-id="element-48">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-49">
          Más los <span className="text-violet-700" data-id="element-50">6 Bonos Estratégicos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-51">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-52">
          <div className="bg-violet-700 px-5 py-3" data-id="element-53">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-54">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-55">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2.5" data-id="element-56">
                <span className="shrink-0 text-lg font-black text-violet-700/30 w-8 text-center" data-id="element-57">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-58">
                  <span className="block text-sm font-black text-gray-900" data-id="element-59">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-60">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-61">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-62">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-violet-700 rounded-full px-2 py-0.5" data-id="element-63">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgb(245, 243, 255)',
        border: '1px solid rgba(124, 58, 237, 0.3)'
      }} data-id="element-64">
          <p className="text-xs font-bold uppercase tracking-widest text-violet-700 m-0 mb-1" data-id="element-65">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-66">
            <span className="text-base text-gray-400 line-through" data-id="element-67">
              $58.000
            </span>
            <span className="text-lg font-black text-violet-700" data-id="element-68">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}